
import axios from 'axios';

import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
/**
 * Secure Procedure Result Service
 * Uses backend API endpoints instead of direct Firestore access
 */

// Get all procedure reports
export async function getProcedureReports(options = {}) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/procedure-reports`, {
      params: options,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data.procedureReports || [];
    }

    throw new Error('Failed to get procedure reports');
  } catch (error) {
    console.error('Error getting procedure reports:', error);
    throw error;
  }
}

// Get procedure results by report ID
export async function getProcedureResults(reportId, options = {}) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/procedure-results`, {
      params: { reportId, ...options },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data.procedureResults || [];
    }

    throw new Error('Failed to get procedure results');
  } catch (error) {
    console.error('Error getting procedure results:', error);
    throw error;
  }
}

// Get procedure report by ID
export async function getProcedureReportById(reportId) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/procedure-reports/${reportId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get procedure report');
  } catch (error) {
    console.error('Error getting procedure report:', error);
    throw error;
  }
}

// Get procedure results by patient ID
export async function getPatientProcedureResults(patientId, options = {}) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/procedure-results/patient`, {
      params: { patientId, ...options },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data.procedureResults || [];
    }

    throw new Error('Failed to get patient procedure results');
  } catch (error) {
    console.error('Error getting patient procedure results:', error);
    throw error;
  }
}

// Create a new procedure report
export async function createProcedureReport(reportData) {
  try {
    const token = await getAuthToken();
    const response = await axios.post(`${API_BASE}/clinical/procedure-reports`, reportData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 201) {
      return response.data;
    }

    throw new Error('Failed to create procedure report');
  } catch (error) {
    console.error('Error creating procedure report:', error);
    throw error;
  }
}

// Update a procedure report
export async function updateProcedureReport(reportId, updateData) {
  try {
    const token = await getAuthToken();
    const response = await axios.put(`${API_BASE}/clinical/procedure-reports/${reportId}`, updateData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to update procedure report');
  } catch (error) {
    console.error('Error updating procedure report:', error);
    throw error;
  }
}

// Add results to a procedure report
export async function addProcedureResults(reportId, resultsData) {
  try {
    const token = await getAuthToken();
    const response = await axios.post(`${API_BASE}/clinical/procedure-reports/${reportId}/results`, resultsData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 201) {
      return response.data;
    }

    throw new Error('Failed to add procedure results');
  } catch (error) {
    console.error('Error adding procedure results:', error);
    throw error;
  }
}
